<script setup lang="ts">
import { tpgIconMoreVert } from '@tpg/grammar-web-icons';

import type {
  GrammarMenuItemProps,
} from '@nora-monorepo/grammar-ui';
import {
  GrammarMenuItem,
  GrammarQuaternaryMenuButton,
} from '@nora-monorepo/grammar-ui';

defineProps<{
  menuItems: GrammarMenuItemProps[];
}>();
</script>

<template>
  <GrammarQuaternaryMenuButton :icon-template="tpgIconMoreVert" size="small">
    <GrammarMenuItem
      v-for="(item, key) in menuItems"
      :key="key"
      v-bind="item"
    />
  </GrammarQuaternaryMenuButton>
</template>
